<button mat-icon-button class="dialog-close-btn" (click)="onNoClick()"><mat-icon>close</mat-icon></button>
<h1 mat-dialog-title>
  Datawrapper
</h1>
<div mat-dialog-content>
  <iframe class="w-100" src="https://app.datawrapper.de/create/chart/" frameborder="0"></iframe>
</div>
